export default __webpack_public_path__ + "static/media/asab2022_small.1564dc97.jpg";